import { createFileRoute } from "@tanstack/react-router";
import { CursorCandles } from "@/components/CursorCandles";
import { Crosshair } from "@/components/Crosshair";
import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";
import { TrendingBoard } from "@/components/rank/TrendingBoard";

export const Route = createFileRoute("/trending")({
  head: () => ({
    meta: [
      { title: "Trending — Top ranked X accounts on Hoodrank" },
      {
        name: "description",
        content:
          "The 20 highest-signal X accounts in the Robinhood chain ecosystem right now, ranked by who follows them.",
      },
      { property: "og:title", content: "Trending — Hoodrank" },
      {
        property: "og:description",
        content: "Top ranked accounts right now: score, follower quality and score changes.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: TrendingPage,
});

function TrendingPage() {
  return (
    <>
      <CursorCandles />
      <Crosshair />
      <SiteHeader />

      <main data-candles className="grid-paper min-h-[calc(100vh-4rem)]">
        <div className="shell py-14 md:py-20">
          <p className="label mb-6">Index · top 20</p>
          <h1 className="max-w-[14ch] !text-[clamp(44px,7vw,104px)]">
            Trend<span className="hollow">ing</span>
          </h1>
          <p className="mt-5 max-w-[52ch] text-[17px] text-ink-soft">
            Accounts gaining signal right now. Switch 7D / 30D to reorder by Sorsa score momentum
            for that window.
          </p>

          <TrendingBoard />

          <p className="mono mt-6 text-[12px] text-ink-muted">
            Live via Hoodrank API (tracked Robinhood ecosystem handles).
          </p>
        </div>
      </main>

      <SiteFooter />
    </>
  );
}
